import { isServer } from '../../browser'
import { getMobileDeviceType } from '../../deviceType'
import { logError } from '../../logError'

const KEY = 'CT_WEB_PUSH_PROMPTED'

export function requestCleverTapWebPush() {
    try {
        if (isServer()) return

        const deviceType = getMobileDeviceType()
        if (deviceType === 'AndroidApp' || deviceType === 'iPhoneApp') return

        if (localStorage.getItem(KEY)) return

        if (!('Notification' in window) || Notification.permission !== 'default') {
            localStorage.setItem(KEY, 'true')
            return
        }

        if (typeof window.clevertap?.notifications?.push !== 'function') return

        localStorage.setItem(KEY, 'true')
        window.clevertap.notifications.push({
            askAgainTimeInSeconds: 5,
            serviceWorkerPath: '/clevertap_sw.js'
        })
    } catch (e) {
        logError('requestCleverTapWebPush', e)
    }
}
